import { LanguageRegionCode, LanguageCode } from '@alltrails/shared/utils/languageSupport';
import useLanguageRegionCode from './useLanguageRegionCode';

export default function useLanguageCode(): LanguageCode {
  const languageRegionCode: LanguageRegionCode = useLanguageRegionCode();
  return languageRegionCode.split('-')[0] as LanguageCode;
}
